<template>
  <b-form-group>
    <b-input-group class="mb-3">
      <b-input-group-prepend>
        <b-input-group-text>
          <i style="font-size:18px" class="fa">&#xf002;</i>
        </b-input-group-text>
      </b-input-group-prepend>
      <b-form-input
        v-model="query"
        type="text"
        :placeholder="
          $store.getters['translations/getLabel']('SEARCH_PLACEHOLDER') ||
            'Search...'
        "
        @input="handleInput"
      />
    </b-input-group>
  </b-form-group>
</template>
<script>
export default {
  name: 'SearchBox',
  props: {
    value: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      query: this.value || '',
    };
  },
  watch: {
    value() {
      this.query = this.value;
    },
  },
  methods: {
    handleInput() {
      this.$emit('input', this.query);
    },
  },
};
</script>
